<!-- <app-survay-header></app-survay-header> -->
<div class="Main-Cont">
    <div class="Ques-Cont">
        <div class="text-dark fs-5 fw-bold">
            <!-- What is your Gender&#63; -->
            {{qService.currentQuestion.question_text}}
        </div>
        <div class="text-muted fs-6 fw-normal mt-2">
            Please provide the counts below
        </div>
        <div [ngClass]="qService.currentQuestion.options.length>9?'largeCounter-Cont':'smallCounter-Cont'">
            <ng-container *ngFor="let Ques of format_counter_option ;let i=index">
                <div class="Counter-div border-bottom">
                   <div>
                    {{Ques.text}}
                   </div>
                   <div class="Inc-Dec-sec">
                       <div class="border"  (click)="decreaseCount(i)">
                           <img src="../../../assets/image/addremove.png" />
                       </div>
                       <div class="border border-primary">
                           {{Ques.misc.rank}}
                        </div>
                        <div class="border" (click)="increaseCount(i)">
                            <img src="../../../assets/image/add.png" />
                        </div>
                   </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="footer">
        <div class="text-dark fw-bold fs-4  text-end">Q{{qService.currentQuestion.ques_index}}</div>
        <div class="text-end">
            <button class="btn btn-primary" (click)="next()">Next</button>
        </div>
    </div>
</div>
